import { IconProp, SizeProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/";
import React from "react";
import { CSSProperties } from "styled-components";

import { useTheme } from "../ThemeContext";
import { ThemeType } from "../theme/Theme";

interface AtiraIconProps {
  color?: keyof ThemeType;
  icon: IconProp;
  size?: SizeProp;
  cursor?: CSSProperties["cursor"];
  style?: CSSProperties;
  width?: CSSProperties["width"];
  className?: string;
  animations?: ("spin" | "pulse" | "bounce" | "fade" | "beat")[];
}

export const AtiraIcon: React.FC<AtiraIconProps> = ({
  color,
  icon,
  size = "1x",
  cursor,
  style,
  width,
  className,
  animations = [],
}) => {
  const { theme } = useTheme();
  const animationProps = animations.reduce(
    (acc, anim) => ({ ...acc, [anim]: true }),
    {},
  );

  return (
    <FontAwesomeIcon
      icon={icon}
      color={theme?.[color!]}
      size={size}
      cursor={cursor}
      style={style}
      width={width}
      className={className}
      {...animationProps}
    />
  );
};
